





































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';
import { ITax } from '@/models';
import { useFetchTaxes, useDeleteTax } from '@/composable/tax';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import TaxFormDialog from '@/components/tax/TaxFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'TaxListPage',
  mixins: [authMixin],
  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    TaxFormDialog
  },
  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: '#', value: 'index', sortable: false, width: 5 },
      { text: 'Name', value: 'name', sortable: false },
      { text: 'Rate', value: 'rate', sortable: false },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedTax = ref<ITax | null>(null);

    function openTaxDialog(tax?: ITax) {
      dialog.value = true;
      selectedTax.value = tax ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteTax,
      reset: deleteReset
    } = useDeleteTax();

    const deleteDialog = ref(false);
    function openDeleteTaxDialog(tax: ITax) {
      selectedTax.value = tax;
      deleteDialog.value = true;
    }

    function closeDrawerAndDialog() {
      drawer.value = false;
      deleteDialog.value = false;
    }

    function removeTax(vehicle: ITax) {
      deleteTax(vehicle.id!, {
        onSuccess: () => {
          closeDrawerAndDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const { taxes, error, isLoading } = useFetchTaxes();

    const drawer = ref(false);
    function openTaxDrawer(tax: ITax) {
      selectedTax.value = tax;
      drawer.value = true;
    }

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      drawer,
      selectedTax,
      moment,
      dialog,
      currentSearch,
      taxes,
      isLoading,
      headers,
      error,
      openTaxDialog,
      clearAllErrors,
      openDeleteTaxDialog,
      openTaxDrawer,
      closeDrawerAndDialog,
      removeTax
    };
  }
});
